"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidateNestedFull = ValidateNestedFull;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
// function to perform nested validation of all nested fields regardless of the validation groups used in the parent class
// validation groups are present in the validationOptions but they are purposely ommited for validateSync calls
function ValidateNestedFull(schema, validationOptions) {
    return function (object, propertyName) {
        (0, class_validator_1.registerDecorator)({
            name: "ValidateNested",
            target: object.constructor,
            propertyName: propertyName,
            constraints: [],
            options: validationOptions,
            validator: {
                validate(value /*, args: ValidationArguments*/) {
                    if (Array.isArray(value)) {
                        for (let i = 0; i < value.length; i++) {
                            if ((0, class_validator_1.validateSync)((0, class_transformer_1.plainToClass)(schema, value[i])).length) {
                                return false;
                            }
                        }
                        return true;
                    }
                    else {
                        return (0, class_validator_1.validateSync)((0, class_transformer_1.plainToClass)(schema, value)).length === 0;
                    }
                },
                defaultMessage(args) {
                    if (Array.isArray(args?.value)) {
                        for (let i = 0; i < args.value.length; i++) {
                            const err = (0, class_validator_1.validateSync)((0, class_transformer_1.plainToClass)(schema, args.value[i]));
                            if (err.length > 0) {
                                const errString = getErrorsArr(err, propertyName).join("\n");
                                return [`${args.property}::index${i} ->`, errString].join("\n");
                            }
                        }
                    }
                    else {
                        return (`${args?.property}: ` +
                            (0, class_validator_1.validateSync)((0, class_transformer_1.plainToClass)(schema, args?.value))
                                .map((e) => e.constraints)
                                .reduce((acc, next) => (next ? acc.concat(Object.values(next)) : acc), [])).toString();
                    }
                    return "";
                },
            },
        });
    };
    function getErrorsArr(errors, propertyName) {
        const directErrors = errors
            .map((e) => e.constraints)
            .reduce((acc, next) => (next ? acc.concat(Object.values(next).map((err) => `${propertyName}: ${err}`)) : acc), []);
        const childrenErrors = errors.flatMap((error) => {
            return error.children && error.children.length > 0 ? getErrorsArr(error.children, error.property) : [];
        });
        return directErrors.concat(childrenErrors);
    }
}
//# sourceMappingURL=FullNestedValidator.js.map